var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "authentication-code-container" } }, [
    _c(
      "div",
      { staticClass: "tabs-bar" },
      [
        _c("TabsBar", {
          attrs: {
            tabNames: [
              _vm.$t("authenticationCode.contactType.email"),
              _vm.$t("authenticationCode.contactType.sms"),
            ],
            getCurrentTab: _vm.getActiveIndex,
            defaultIndex: 0,
            disabledTabs: _vm.noSMS
              ? [_vm.$t("authenticationCode.contactType.sms")]
              : [],
            disableSwitch: _vm.ifStartCountDown,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", [
        _c("label", { staticClass: "field-label" }, [
          _vm._v(
            _vm._s(_vm.$t("authenticationCode.contactType." + _vm.contactType))
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-field" }, [
          _c("div", [
            _c("p", { staticClass: "content" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.contactAddress) + "\n          "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "message" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "authenticationCode.message." +
                        _vm.contactType +
                        "." +
                        _vm.sendCodeStatus,
                      [_vm.codeExpireInMin]
                    )
                  ) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-button" }, [
            _c(
              "button",
              {
                staticClass: "btn action-btn btn--darkblue",
                attrs: {
                  disabled:
                    _vm.currentSendCodeStatus === 1 ||
                    _vm.currentSendCodeStatus === -1,
                },
                on: { click: _vm.onSendButtonClick },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("authenticationCode.button." + _vm.sendCodeStatus)
                    ) +
                    "\n            "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentSendCodeStatus === 1,
                        expression: "currentSendCodeStatus === 1",
                      },
                    ],
                  },
                  [
                    _vm._v("("),
                    _c("CountDown", {
                      attrs: {
                        trigger: _vm.ifStartCountDown,
                        onStart: _vm.onCountDownStart,
                        onEnd: _vm.onCountDownEnd,
                        defaultStartIndex: 60,
                      },
                    }),
                    _vm._v("s)"),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", { staticClass: "field-label" }, [
          _vm._v(_vm._s(_vm.$t("authenticationCode.base.verificationCode"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-field" }, [
          _c("div", [
            _c(
              "div",
              { staticClass: "code-input" },
              [_c("InputField", { on: { input: _vm.onInputChange } })],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-button" }, [
            _c(
              "button",
              {
                staticClass: "btn action-btn btn--orange",
                attrs: { disabled: !_vm.canClickLoginButton },
                on: { click: _vm.onLoginButtonClick },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t("login")) + "\n          "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }